// Shared drill-down modal for dashboard tiles — shows Employee Id / Name / the relevant date for
// whichever tile was clicked. Rows are generic {EmpRefNo, EmpName, DetailDate} so this same modal
// works for any dashboard's tile drill-downs, not just HR's.
import React from 'react';
import { X, Loader2 } from 'lucide-react';

const DetailListModal = ({ open, onClose, title, subtitle, loading, rows = [], dateColumnLabel = 'Date' }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
            <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 w-full max-w-2xl max-h-[80vh] flex flex-col">
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 dark:border-gray-700 bg-orange-50 dark:bg-orange-900/20 rounded-t-2xl flex-shrink-0">
                    <div>
                        <h2 className="text-base font-bold text-gray-800 dark:text-gray-100">{title}</h2>
                        {subtitle && <p className="text-xs text-gray-500 dark:text-gray-400">{subtitle}</p>}
                    </div>
                    <button onClick={onClose}
                        className="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="flex-1 overflow-auto">
                    {loading ? (
                        <div className="flex items-center justify-center py-12 gap-2 text-gray-400 dark:text-gray-500">
                            <Loader2 className="w-5 h-5 animate-spin" /> Loading…
                        </div>
                    ) : rows.length === 0 ? (
                        <div className="flex items-center justify-center py-12 text-gray-400 dark:text-gray-500 text-sm">
                            No employees found
                        </div>
                    ) : (
                        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                            <thead className="bg-gray-50 dark:bg-gray-900/40 sticky top-0">
                                <tr>
                                    <th className="px-4 py-2 text-left text-[11px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Employee Id</th>
                                    <th className="px-4 py-2 text-left text-[11px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Employee Name</th>
                                    <th className="px-4 py-2 text-right text-[11px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">{dateColumnLabel}</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100 dark:divide-gray-700">
                                {rows.map((row, idx) => (
                                    <tr key={`${row.EmpRefNo}-${idx}`} className="hover:bg-gray-50 dark:hover:bg-gray-700/40">
                                        <td className="px-4 py-2 text-sm text-gray-900 dark:text-white">{row.EmpRefNo}</td>
                                        <td className="px-4 py-2 text-sm text-gray-700 dark:text-gray-300">{row.EmpName}</td>
                                        <td className="px-4 py-2 text-sm text-right text-gray-900 dark:text-white whitespace-nowrap">{row.DetailDate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DetailListModal;
